import axios from 'axios';

axios.defaults.xsrfHeaderName = `X-CSRFToken`;
axios.defaults.xsrfCookieName = `csrftoken`;

const request = async ({ method, url, data, headers }) => {
  try {
    const response = await axios({
      method,
      url,
      data,
      headers,
    });
    return response;
  } catch (e) {
    if (e instanceof Error) {
      throw e;
    } else if (typeof e === `object`) {
      throw new Error(JSON.stringify(e));
    } else {
      throw new Error(e);
    }
  }
};

export default request;
